/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StoryRatingContainer_story = {
    readonly id: string;
    readonly metadata: {
        readonly title: string | null;
    } | null;
    readonly ratings: {
        readonly average: number;
        readonly count: number;
    } | null;
    readonly " $refType": "StoryRatingContainer_story";
};
export type StoryRatingContainer_story$data = StoryRatingContainer_story;
export type StoryRatingContainer_story$key = {
    readonly " $data"?: StoryRatingContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"StoryRatingContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoryRatingContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StoryMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StoryRatings",
            "kind": "LinkedField",
            "name": "ratings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "average",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "count",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '592e6574984d264dad62ea31c733eae9';
export default node;
